export default __webpack_public_path__ + "static/media/Package.a0d22553.svg";